import { render, staticRenderFns } from "./fileEditImage.vue?vue&type=template&id=8b35f876&scoped=true"
import script from "./fileEditImage.vue?vue&type=script&lang=js"
export * from "./fileEditImage.vue?vue&type=script&lang=js"
import style0 from "./fileEditImage.vue?vue&type=style&index=0&id=8b35f876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b35f876",
  null
  
)

export default component.exports